// extracted by mini-css-extract-plugin
module.exports = {"searchPaper":"globalSearch_searchPaper__yqvU_","input":"globalSearch_input__t0PAX","iconButton":"globalSearch_iconButton__qLZWM"};